import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    catalog(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                // const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemcode', 'itemname'];
                const keys = ['page', 'limit', 'itemcode', 'itemname'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                if (obj.cats.length > 0) {
                    // str += '&cat=' + encodeURIComponent(JSON.stringify(obj.cats));
                    str += '&cat=' + encodeURIComponent(obj.cats.join('|'));
                }
                const url = `/bakeryitem/catalog${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                const newArr = list.map((i) => {
                    // i.src = `${process.env.VUE_APP_BASE_API}/image/item1/${i.itemno}`;
                    return {
                        itemno: i.itemno, itemname: i.itemname, partnumber: i.partnumber,
                        src:`${process.env.VUE_APP_BASE_API}/image/item1/${i.itemno}`,
                        invunitom: i.invunitom
                        };
                });
                resolve(newArr);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    cataloggroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/bakeryitem/cataloggroup`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    itemimages(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/bakeryitem/images/${obj.itemno}`);
                console.log('bakeryitem images ',data);
                resolve(data.map(i => i.src = `${process.env.VUE_APP_BASE_API}/image/bakeryitem/${i.imgKey}`));
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },    
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemcode', 'itemname', 'headcategory', 'itemcategory', 'group','jasa','isactive'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryitem${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    listcustprice(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemcode', 'itemname', 'headcategory', 'itemcategory', 'group','jasa','isactive','customer_id'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryitem/custprice${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    listsaldo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'itemcode', 'itemname', 'headcategory', 'itemcategory', 'group','jasa','isactive'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakeryitem/listsaldo${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                // delete data.materials;
                const resp = await axios.post('/bakeryitem', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    token(){
        return new Promise(async (resolve, reject) => {
            try {
                const APP_AUTH_TK = process.env.VUE_APP_AUTH_TK;
                const data = JSON.parse(localStorage.getItem(APP_AUTH_TK));
                data.baseURL = process.env.VUE_APP_BASE_API;
                data.headers = { 'authorization': data.token };
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });

    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/bakeryitem/${obj.itemno}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/bakeryitem/detail/${obj.itemno}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    images(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/bakeryitem/images/${obj.itemno}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    group() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/bakeryitem/itemcategory`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    headgroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/bakeryitem/headcategory`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    store() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventory/store`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
        try {
            const keys = ['sortBy', 'sortDir', 'itemcode', 'itemname', 'headcategory', 'itemcategory', 'group', 'jasa', 'isactive'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            axios({
                url: `/bakeryitem/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'item_list.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
}    
};